import { AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios';
import { axios } from './interceptors/request.interceptor';
import { ACCESS_TOKEN, API_BASE_URL, REFRESH_TOKEN } from 'constant';
import { ILoginApiResponse } from 'interfaces/auth.interfaces';
import ILoginForm from 'interfaces/LoginForm.interface';
import { ILoginFormWithWallet } from 'interfaces/LoginFormWithWalletCopy';
import { UserData } from 'interfaces/UserData.interface';

export const apiInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 0,
  headers: {},
  transformRequest: [
    function (data, headers) {
      // Do whatever you want to transform the data
      // console.log(data, headers);
      return data;
    },
  ],
});

export const loginUser = async (
  data: ILoginForm
): Promise<ILoginApiResponse | null> => {
  const config: AxiosRequestConfig<{}> = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  let res: AxiosResponse<ILoginApiResponse>;
  try {
    res = await apiInstance.post('auth/signin/', JSON.stringify(data), config);
    if (res.status === 200) {
      return res.data;
    }
  } catch (error: any) {
    console.error(error);
    // return error.response;
  }
  return null;
};

export const registerUser = async () => {
  const config: AxiosRequestConfig<{}> = {};
  let res: AxiosResponse;
  try {
    // res = await apiInstance.get('/');
    res = await apiInstance.post('api/token/', {}, config);
    if (res.status === 200) {
      localStorage.setItem(ACCESS_TOKEN, '');
      localStorage.setItem(REFRESH_TOKEN, '');
    }
  } catch (error) {
    console.log(error);
  }
};

export const getUserData = async (token?: string): Promise<UserData | null> => {
  const config: AxiosRequestConfig<AxiosRequestHeaders> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  try {
    const res = await apiInstance.get<UserData>(
      `users/me${token ? `?token=${token}` : ''}`,
      config
    );
    if (res.status === 200) {
      return res.data;
    }
  } catch (error: any) {
    if (error.response?.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
    }
  }
  return null;
};

export const loginUserWithWallet = async (
  data: ILoginFormWithWallet
): Promise<ILoginApiResponse | null> => {
  const config: AxiosRequestConfig<string> = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  try {
    const res = await apiInstance.post<ILoginApiResponse>(
      'auth/signin-wallet/',
      JSON.stringify(data),
      config
    );
    if (res.status === 200) {
      return res.data;
    }
  } catch (error: any) {
    console.error(error);
    // return error.response;
  }
  return null;
};

// TODO: uncomment the email
export const loginUserWithEmail = async (
  email: string,
  torusWalletId: string,
  origin: string,
  creatorToken?: string
): Promise<AxiosResponse<ILoginApiResponse>> => {
  const config: AxiosRequestConfig<string> = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return await apiInstance.post<ILoginApiResponse>(
    'auth/signin-email/',
    // TODO: also include the email here
    JSON.stringify({ torusWalletId, creatorToken, clientType: origin, email }),
    config
  );
};

export const updateUser = async (data: Partial<UserData>) => {
  const config: AxiosRequestConfig<AxiosRequestHeaders> = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  try {
    const res = await apiInstance.patch<{ id: number }>(
      'users/update/',
      JSON.stringify(data),
      config
    );
    if (res.status === 200) {
      return res.data;
    }
  } catch (error: any) {
    console.error(error);
    // return error.response;
  }
  return null;
};
